var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sAlert',{staticClass:"version",attrs:{"show-icon":""}},[_vm._v(" "+_vm._s(_vm.$t('Common.ApplicationInformation'))+" "),_c('template',{slot:"desc"},[_c('div',[_vm._v(_vm._s(_vm.$t('Common.Version'))+": "+_vm._s(_vm.version))]),_c('div',[_vm._v(_vm._s(_vm.$t('Common.BuildVersion'))+": "+_vm._s(_vm.buildVersion))])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }